import Axios from 'axios'
const p = (path = '') => `${window.$ApiHost}/publications/${path ? path + '/' : path}`

const state = {
  items: [],
  isHave: true,
  totalPages: 0,
}

const mutations = {
  SET_ITEMS(state, { totalItems, results, totalPages }) {
    state.items = results
    state.isHave = state.items.length < totalItems
    state.totalPages = totalPages
  },
  DELETE_ITEM(state, id) {
    state.items = state.items.filter(el => el.id !== id)
  },
}

const actions = {
  async getItems({ commit }, params) {
    let response
    try {
      response = await Axios.get(p(), { params })
      commit('SET_ITEMS', { ...response.data, totalItems: response.data.total_objects, totalPages: response.data.total_pages })
    } catch (error) {
      response = error.response
    }
    return response
  },
  async getSingle({ commit }, id) {
    let response
    try {
      response = await Axios.get(p(id))
    } catch (error) {
      response = error?.response
    }
    return response
  },
  async delete({ commit }, id) {
    let response
    try {
      response = await Axios.delete(p(id))
      commit('DELETE_ITEM', id)
    } catch (error) {
      response = error.response
    }
    return response
  },
  // eslint-disable-next-line camelcase
  async getSvcPublications(_, { publications_id = [] }) {
    let response
    try {
      response = await Axios.post(p('export'), { publications_id })

      const blob = new Blob([response.data])
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `publications-${new Date()}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    } catch (error) {
      response = error?.response
    }
    return response
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
